import * as config from "util/config";

/**
 * Landing route for the Payments and Services module (AFIP / ARCA): under the v3 UX shell it stays
 * aligned with `/v2/payments-services`; when the flag is off, it remains `/servicePayments`.
 */
export function isServicePaymentsPath(pathname) {
    return pathname === "/servicePayments" || pathname === "/v2/payments-services";
}

export function isServicePaymentsModuleContinuationPath(pathname) {
    if (!pathname || typeof pathname !== "string") {
        return false;
    }
    if (isServicePaymentsPath(pathname)) {
        return true;
    }
    if (pathname === "/multiplePaymentsConfirmation" || pathname === "/multiplePaymentsSuccess") {
        return true;
    }
    if (pathname.startsWith("/newPayment")) {
        return true;
    }
    if (pathname.startsWith("/agenda/payment")) {
        return true;
    }
    if (pathname.startsWith("/agenda/multiplePayment")) {
        return true;
    }
    if (pathname === "/agendaServicePaymentsConfirmationTicket") {
        return true;
    }
    if (pathname.startsWith("/v2/payThirdParties/newPayment") || pathname.startsWith("/payThirdParties/newPayment")) {
        return true;
    }
    return false;
}

export function isUxPaymentsServicesImprovementsEnabled() {
    return config.getBoolean("frontend.vepsPayments.functionalities", false);
}

export function getServicePaymentsPath() {
    return isUxPaymentsServicesImprovementsEnabled() ? "/v2/payments-services" : "/servicePayments";
}
